import React, {FC} from 'react';
import styled from 'styled-components';
import {Flyout} from '../../atoms/Flyout/Flyout';
import {PushNotificationBody} from '../../molecules/PushNotification/PushNotificationBody';
import {
  PushNotificationHeader,
  PushNotificationType,
} from '../../molecules/PushNotification/PushNotificationHeader';

interface PushNotificationFlyoutProps {
  open: boolean;
  onClose: () => void;
  onBodyContentClick?: () => void;
}

type PushNotificationFlyoutPropsWithType = PushNotificationFlyoutProps & {
  type: PushNotificationType;
};

export const PushNotificationFlyout: FC<
  PushNotificationFlyoutPropsWithType
> = ({open, type, onClose, onBodyContentClick}) => {
  return (
    <StyledFlyout
      onClose={onClose}
      open={open}
      data-testid="pushNotificationsFlyout"
      headerContent={<PushNotificationHeader type={type} />}
      bodyContent={
        <PushNotificationBody
          onBodyContentClick={onBodyContentClick}
          onClose={onClose}
        />
      }
    />
  );
};

const StyledFlyout = styled(Flyout)`
  height: 100vh;
  // this is needed to prevent the flyout from being cut off on mobile devices due to the classic issue of using vh units on mobile devices
  height: -moz-available;
  height: -webkit-fill-available;
  bottom: 0;
`;
